export const LOG_EVENTS = {
  VIDEO_CLICK: 'DaS FinSuite -> User Action: Tutorials -> Video Click'
} as const;
